import * as React from "react";
import {UserResource} from "client/resources";
import AvatarMaterial from "material-ui/Avatar";

import styles = require("./style.less");

const avatarPlaceHolder = require("./img/avatar-placeholder.svg");
const octopusServiceImage = require("./img/octopus-service-440.svg");
const userDefaultImage = require("./img/user-placeholder.svg");

interface AvatarProps {
    user?: UserResource;
    size?: number;
}

export const Avatar: React.StatelessComponent<AvatarProps> = props => {
    const size = props.size || 25;
    let imageSource = avatarPlaceHolder;
    if (!props.user) {
        imageSource = octopusServiceImage;
    } else if (props.user.IsService) {
        imageSource = octopusServiceImage;
    } else if (props.user.Links && props.user.Links.Avatar) {
        imageSource = `${props.user.Links.Avatar}&s=${size}`;
    }
    return (
        <AvatarMaterial style={{backgroundImage: `url("${userDefaultImage}")`}} src={imageSource} size={size} />
    );
};

export default Avatar;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Avatar/Avatar.tsx